import { __awaiter } from "tslib";
import { useCallback } from "react";
import { useSubstructureApi, useSubstructureInstanceMeta, } from "@plansoft-configuration-renderer/framework";
import { useUiTranslator } from "@plansoft-configuration-renderer/localization";
/**
 * Get props for SubstructureInstanceInsertButton
 * @param options
 * @returns
 */
export function useSubstructureInstanceInsertButtonProps(options) {
    const { substructure } = options;
    const t = useUiTranslator();
    const { addSubCfgObject, moveSubCfgObject } = useSubstructureApi();
    const { canAdd, isSingleInstance, attributePath, instancePath, numInstances, } = useSubstructureInstanceMeta(substructure);
    const onClick = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        if (!canAdd) {
            return;
        }
        const lastItemPath = `${attributePath}/${numInstances}`;
        // add it as the last item
        yield addSubCfgObject({ path: attributePath });
        // move the last added item to the target path
        yield moveSubCfgObject({
            path: lastItemPath,
            targetPath: instancePath,
        });
    }), [
        canAdd,
        addSubCfgObject,
        attributePath,
        instancePath,
        moveSubCfgObject,
        numInstances,
    ]);
    return {
        title: t("ConfigurationRenderer:SubconfigurationInstance.insert", "Add"),
        disabled: !canAdd,
        hideDisabled: isSingleInstance,
        onClick,
    };
}
//# sourceMappingURL=useSubstructureInstanceInsertButtonProps.js.map